/**
 * Created by strunz on 29.03.2017.
 */

import {EventEmitter, Injectable} from '@angular/core';
import {Option} from '../classes/option';
import {Product} from '../classes/product';
import {DataService} from './data.service';

@Injectable()
export class StorageService {
    options: Option[];
    products: Product[] = Array();
    showAbleProductCount: number;
    public resultUpdated$: EventEmitter<Boolean>;
    public product = 'all';

    constructor(private dataService: DataService) {
        this.resultUpdated$ = new EventEmitter();
    };

    updateOptions(): void {

        for (const optionKey in this.options) {
            for (const optionItem of this.options[optionKey].getAllItems()) {
                optionItem.disabled = true;
                optionItem.count = 0;
            }
        }

        this.updateResultList();

        for (const optionKey in this.options) {
            if (typeof this.options[optionKey].update === 'function') {
                this.options[optionKey].update();
            }
        }
        this.dataService.setOptions(this.product, this.options);
    }

    updateResultList(): void {
      this.showAbleProductCount = 0;
        this.resultUpdated$.emit(true);
        for (const optionName in this.options) {
            this.options[optionName].ignore = true;
            for (const product of this.products) {
                for (const program of product.programs) {
                    program.updateShowAble();
                    if (program.showAble) {
                        if (!program.options[optionName]) {
                            console.error(optionName + ' missing', program);
                        } else {
                            for (const optionItem of program.options[optionName].getAllItems()) {
                                optionItem.disabled = false;
                                optionItem.count++;
                            }
                        }
                    }
                }
            }
            this.options[optionName].ignore = false;
        }

        this.showAbleProductCount = 0;
        for (const product of this.products) {
            for (const program of product.programs) {
                program.updateShowAble();
                if (program.showAble) {
                    this.showAbleProductCount++;
                }
            }
        }


    }
}
